export default {
  line_items: [
    {
      lead_times : [6, 8, 10],
      pricing    : [
        [0, 0, 0],
        [0, 0, 0],
        [0, 0, 0],
      ],
      quantities: [
        'First Articles (1-10)',
        'Low Production (11-1000)',
        'High Production (>1000)',
      ],
      product_key: 'mx-pcb-assembly',
    },
  ],
};
